"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class ProspectiveBuyerModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            contactId: 'McLabs2__Contact__c',
            listingId: 'McLabs2__Listing__c',
            ownerId: 'OwnerId',
            status: 'McLabs2__Status__c'
        };
    }
}
ProspectiveBuyerModel.STATUSES = [
    'Prospect',
    'Materials Sent',
    'Toured',
    'Offered',
    'Passed'
];
exports.ProspectiveBuyerModel = ProspectiveBuyerModel;
//# sourceMappingURL=prospective-buyer.model.js.map